import { render, staticRenderFns } from "./DataTableFooter.vue?vue&type=template&id=79ee2ccc&scoped=true&"
import script from "./DataTableFooter.vue?vue&type=script&lang=ts&"
export * from "./DataTableFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableFooter.vue?vue&type=style&index=0&id=79ee2ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ee2ccc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDivider,VIcon,VRow,VSelect})
